export var CHAT_MSG_TYPE={
    WORD:1,
    VOICE_STREAM:2,
    IMG:3
}
export var CHAT_EVNET ={
    PREPARE_AUDIO:'prepare',
    START_AUDIO:'start',
    END_AUDIO:'end',
    ERROR_AUDIO:'error',
    MUTED_PLAY:'muted'
}


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/define.js